import React from 'react';
import {
	LineChart,
	XAxis,
	YAxis,
	CartesianGrid,
	Line,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';

const Linechart = props => {
	const { containerProps, lineChartProps, data, xAxisKey, lineData, formatter } = props;
	return (
		<ResponsiveContainer width="100%" height="80%" aspect={4.0 / 3.2} {...containerProps}>
			<LineChart
				data={data}
				height={250}
				margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
				{...lineChartProps}
			>
				<XAxis dataKey={xAxisKey} />
				<YAxis />
				<CartesianGrid strokeDasharray="3 3" />
				<Tooltip formatter={value => (formatter ? `${value} ${formatter}` : value)} />
				<Legend />
				<Line
					type="monotone"
					dataKey={lineData.key}
					stroke={lineData.stroke || '#00bcd4'}
					fill={lineData.fill || '#00bcd4'}
				/>
			</LineChart>
		</ResponsiveContainer>
	);
};

export default Linechart;
